(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function syncTimelineLabels(component) {
    const slides = component.querySelectorAll('slideshow-slide[data-timeline-label]');
    const labels = component.querySelectorAll('.slideshow-timeline__label');
    slides.forEach((slide, i) => {
      if (labels[i]) labels[i].textContent = slide.dataset.timelineLabel || '';
    });
  }

  document.querySelectorAll('slideshow-component').forEach((component) => {
    syncTimelineLabels(component);
    new MutationObserver(() => syncTimelineLabels(component)).observe(component, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-timeline-label'],
    });
  });

  } catch(e) { console.error(e); }
})();
})();
